import React from "react";

const LoadingOverlay = ({
  show = false,
  message = "Enviando...",
  showSuccess = false,
  onClose = () => {},
}) => {
  // Si no hay nada que mostrar, no renderizamos
  if (!show && !showSuccess) return null;

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
      backdropFilter: "blur(2px)",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 12,
      color: "#fff",
      padding: "18px 28px",
      borderRadius: 8,
    },
    spinner: {
      width: 60,
      height: 60,
      borderRadius: "50%",
      border: "5px solid rgba(255,255,255,0.25)",
      borderTop: "5px solid #ffffff",
      animation: "lp-spin 1s linear infinite",
    },
    message: {
      fontSize: 16,
      fontWeight: 500,
    },
    modalContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
    },
    modalBox: {
      backgroundColor: "#fff",
      borderRadius: 10,
      padding: "30px 30px",
      boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
      textAlign: "center",
      maxWidth: 400,
      width: "90%",
    },
    modalTitle: {
      marginBottom: 15,
      color: "#500e70",
      fontWeight: "bold",
    },
    modalText: {
      marginBottom: 20,
      color: "#555",
      fontSize: 15,
    },
    modalButton: {
      padding: "8px 20px",
      backgroundColor: "#8536ae",
      color: "white",
      border: "none",
      borderRadius: 5,
      cursor: "pointer",
      fontWeight: 500,
    },
  };

  return (
    <div style={styles.overlay}>
      {/* Loading spinner */}
      {show && !showSuccess && (
        <div style={styles.container}>
          <div style={styles.spinner} />
          <div style={styles.message}>{message}</div>
        </div>
      )}

      {/* Cuadro blanco de confirmación */}
      {showSuccess && (
        <div style={styles.modalContainer}>
          <div style={styles.modalBox}>
            <h3 style={styles.modalTitle}> CORREO ENVIADO</h3>
            <p style={styles.modalText}>
              Nuestro equipo revisará tu mensaje y se pondrá en contacto contigo
              a la brevedad.
            </p>
            <button style={styles.modalButton} onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* Keyframes para el spinner */}
      <style>{`
        @keyframes lp-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingOverlay;
